import { render } from "./AddDepartmentUser.vue?vue&type=template&id=11f722dc&scoped=true"
import script from "./AddDepartmentUser.vue?vue&type=script&lang=js"
export * from "./AddDepartmentUser.vue?vue&type=script&lang=js"

import "./AddDepartmentUser.vue?vue&type=style&index=0&id=11f722dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f722dc"]])

export default __exports__